module.exports = __webpack_public_path__ + "static/Portfolio05-c08ccca3180101fd7b1344a1ce379296.jpg";